import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, AlertTriangleFillIcon } from '@metarouter-private/mr-mui';

export default function ExportError({ message }) {
  return (
    <Stack spacing={2} alignItems="center" padding={3}>
      <AlertTriangleFillIcon color="error" fontSize="large" />
      <Typography variant="body1" color="error">
        {message}
      </Typography>
    </Stack>
  );
}

ExportError.propTypes = {
  message: PropTypes.string.isRequired,
};
